<template>
<div>

  <Drawer v-model="dialog" :mask-closable="false" width="880" @on-close="closeDialog">
    <div slot="header"><strong>Create Invoice</strong></div>
    <div slot="close"><Icon size="20" class="close-icon" type="md-close" @click="closeDialog"/></div>
    <div class="drawer-body">
      <charges-summary :clientInvoiceId="clientInvoiceId" ref="charges-summary-comp"/>
    </div>
    <div class="drawer-footer">
      <Button type="primary" size="large" @click="validateCharges" :loading="loading">CREATE INVOICE</Button>
      <Button class="close-btn" size="large" @click="closeDialog">CLOSE</Button>
    </div>
  </Drawer>

</div>
</template>

<script>
import {Constants} from "../../../Constants/Constant";
import moment from 'moment';
import ChargesSummary from "../ChargesSummary";
import updateRecord from '../../../mixins/updateRecord';
let user = JSON.parse(localStorage.tatkalorri).userObj.user;
export default {
  name: "PendingApprovalAction",
  components: {ChargesSummary},
  props: ['dialog', 'clientInvoiceId'],
  mixins: [updateRecord],
  data(){
    return{
      Constants: Constants,
      moment: moment,
      loading: false
    }
  },
  methods:{
    async validateCharges(){
      let errors = await this.$refs['charges-summary-comp'].validateCharges();
      if(errors.length) this.showError(errors);
      else this.confirmCreateAction();
    },
    confirmCreateAction(){
      this.$Modal.confirm({
        title: 'Confirm Create Invoice',
        content: '<p>Are you Sure, you want to Create Invoice?</p>',
        onOk: () => {
          this.updateClientInvoiceStatus();
        },
        onCancel: () => {}
      })
    },
    async updateClientInvoiceStatus(){
      this.loading = true;
      let obj = {statusId : Constants.ClientInvoiceStatus.PendingForApproval, updatedBy:user.id};
      await this.updateRecord(this.clientInvoiceId, obj, 'clientInvoices');
      this.$Message.success('Client Invoice updated successfully!');
      this.loading = false;
      this.closeDialog();
    },
    showError(errors){
      this.$Notice.error({
        title: 'Fail to Create Invoice',
        duration: 0,
        desc: errors.map(e => '<li class="fs-16">'+e+'</li>').join('')
      });
    },
    closeDialog(){
      this.$refs['charges-summary-comp'].resetCharges();
      this.$emit('update:clientInvoiceId', null);
      this.$emit('update:dialog', false);
    }
  }
}
</script>

<style scoped>
.drawer-footer{
  position: fixed;
  bottom: 20px;
  width: 100%;
  background: #fff;
  border-top: 1px solid #e8eaec;
  padding: 12px;
  margin: 0 0 -20px -16px;
  z-index: 4;
}
.close-btn{
  margin-left: 10px;
}
</style>
